<!--
 * @Description: 添加作业
 * @Author: PF
 * @Date: 2022-09-23 11:53:32
 * @LastEditors: PF
 * @LastEditTime: 2024-09-29 10:16:58
-->
<template>
  <div class="zuo-ye">
    <el-dialog class="wp80 hp80" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-steps class="mb10" :active="activeName" finish-status="success" simple>
        <el-step title="第一步" />
        <el-step title="第二步" />
      </el-steps>
      <el-form ref="ruleFormRef" :model="ruleForm" class="wp100 hp100" label-width="140px">
        <el-card class="box-card" shadow="never" v-if="activeName===0">
          <template #header>
            <div class="card-header">
              <span>基本信息</span>
            </div>
          </template>
          <el-row>
            <el-col :span="24">
              <el-form-item label="作业名称" prop="zymc" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-input v-model="ruleForm.zymc" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="课程" prop="kcid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-select v-model="ruleForm.kcid" filterable clearable :teleported="false" @change="keChengChange">
                  <el-option v-for="item in kcData" :key="item.id" :label="item.kcmc" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="教学单元" prop="jxdyid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-select class="mr10" v-model="ruleForm.jxdyid" filterable clearable :teleported="false" style="width: calc(100% - 70px);" @change="danDuanChange">
                  <el-option v-for="item in jxdyData" :key="item.id" :label="item.jxdybt" :value="item.id" />
                </el-select>
                <el-button type="primary" @click="openAddJiaoXueDanYuan=true;row={kcid:ruleForm.kcid,kcmc:ruleForm.kcmc}">添加</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="教学内容" prop="jxnrid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-select class="mr10" v-model="ruleForm.jxnrid" filterable clearable :teleported="false" style="width: calc(100% - 70px);">
                  <el-option v-for="item in jxnrData" :key="item.id" :label="item.jxnrbt" :value="item.id" />
                </el-select>
                <el-button type="primary" @click="openAddJiaoXueNeiRong=true;row={kcid:ruleForm.kcid,kcmc:ruleForm.kcmc,jxdyid:ruleForm.jxdyid}">添加</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="box-card" shadow="never" v-if="activeName===1">
          <template #header>
            <div class="card-header">
              <span>作业内容</span>
            </div>
          </template>
            <el-container class="hp100">
              <el-header class="pl0 pr0">
                <div class="button-box">
                  <el-button class="w200 mb10" type="primary" @click="openShiTiDuoTiao=true;row={ids:stids,zylx:ruleForm.zylx,kcid:ruleForm.kcid,jxdyid:ruleForm.jxdyid,jxnrid:ruleForm.jxnrid}"><span class="iconfont icon-chuangjian"></span>添加试题</el-button>
                  <div>总分 {{ ruleForm.zf }} 分</div>
                </div>
              </el-header>
              <el-main class="pl0 pr0">
                <el-table :data="xszys" class="wp100" border height="100%">
                  <el-table-column label="序号" type="index" width="80" fixed align="center" />
                  <el-table-column prop="txbt" label="题型" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="stzw" label="试题正文" align="center" show-overflow-tooltip>
                    <template #default="scope">
                      <p style="white-space: pre-wrap; text-indent:0;" v-html="scope.row.stzw"></p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="jyksdf" label="分值" align="center" show-overflow-tooltip>
                    <template #default="scope">
                      <el-input-number v-model="scope.row.jyksdf" :min="0.1" :precision="1" clearable @change="fenZhiChange" />
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" show-overflow-tooltip width="60">
                    <template #default="scope">
                      <el-button type="text" :underline="false" @click="delGw(scope.$index)">
                        删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-main>
            </el-container>
        </el-card>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button v-if="activeName===1" @click="handleClick(0)">上一步</el-button>
            <el-button v-if="activeName===0" @click="handleClick(1); xsData(ruleForm.zylx)">下一步</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <shitiduotiao v-if="openShiTiDuoTiao" v-model:openDuoTiao="openShiTiDuoTiao" :row="row" @ReturnData="ShiTiDuoTiaoReturnData" />

  <jiaoxuedanyuan v-if="openAddJiaoXueDanYuan" v-model:openAdd="openAddJiaoXueDanYuan" :row="row" @ReturnData="initjxdyList" />
  <jiaoxueneirong v-if="openAddJiaoXueNeiRong" v-model:openAdd="openAddJiaoXueNeiRong" :row="row" @ReturnData="initjxnrList" />
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { loadSelect, submitForm, closeWindow } from '@/api/common.js'
import shitiduotiao from './shitiduotiao.vue'
import jiaoxuedanyuan from '@/components/jiaoxuedanyuan.vue'
import jiaoxueneirong from '@/components/jiaoxueneirong.vue'

const props = defineProps({ openAdd: { type: Boolean, required: true } })
const emits = defineEmits(['update:openAdd', 'ReturnData'])

const ruleFormRef = ref(null)
const ruleForm = ref({
  zf: 100,
  sfjrpscj: true,
  xszys: [],
  xxzy: {}
})
const row = ref()

const openShiTiDuoTiao = ref(false)
const xszys = ref()
const stids = ref()
const ShiTiDuoTiaoReturnData = (data) => {
  if (data) {
    const cd = data.length
    const fz = Number(ruleForm.value.zf / cd)
    xszys.value = data.map((item) => {
      item.jyksdf = fz.toFixed(1)
      item.txbt = item.sylxmclist
      item.stzw = item.zystkstzw
      return item
    })
    stids.value = data.map((item) => item.id)
  }
}
// 计算总分
const fenZhiChange = () => {
  const jyksdf = xszys.value.map((item) => item.jyksdf)
  let sum = 0
  jyksdf.forEach((element) => {
    sum += element
  })
  ruleForm.value.zf = sum.toFixed(1)
}

const xqData = ref() // 加载 学期 下拉框
const kcData = ref() // 加载 课程 下拉框

// 获取试题列表
const xsData = (val) => {
  if (val === 1) {
    loadSelect({
      url: '/api/v2/ziyuanku/shiti/list',
      data: ruleForm.value.xszys,
      parms: { jsstkid: ruleForm.value.kcid },
      order: 'createdTime',
      sort: 'asc'
    })
  }
}
// 下一步
const activeName = ref(0)
const handleClick = (val) => {
  activeName.value = val
  if (val === 3) {
    loadSelect({ url: '/api/v2/pdp/banji/jiaoshi', data: bjData.value })
  }
}

// 选择课程
const keChengChange = (val) => {
  kcData.value.forEach((element) => {
    if (val === element.id) {
      ruleForm.value.kcmc = element.kcmc
      loadSelect({
        url: '/api/v2/ziyuanku/kechengjiaoxuedanyuan/list',
        data: jxdyData,
        parms: { kcid: ruleForm.value.kcid, order: 'sx', sort: 'asc' }
      })
    }
  })
}
// 选择教学单元
const danDuanChange = (val) => {
  jxdyData.value.forEach((element) => {
    if (val === element.id) {
      loadSelect({
        url: '/api/v2/ziyuanku/kechengjiaoxueneirong/list',
        data: jxnrData,
        parms: { jxdyid: ruleForm.value.jxdyid, order: 'sx', sort: 'asc' }
      })
    }
  })
}
// 添加教学单元
const openAddJiaoXueDanYuan = ref(false)
const jxdyData = ref([])
const initjxdyList = () => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxuedanyuan/list',
    parms: { kcid: ruleForm.value.kcid, order: 'sx', sort: 'asc' },
    data: jxdyData
  })
}
// 添加教学内容
const openAddJiaoXueNeiRong = ref(false)
const jxnrData = ref([])
const initjxnrList = () => {
  ruleForm.value.jxnrid = ''
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxueneirong/list',
    parms: { jxdyid: ruleForm.value.jxdyid, order: 'sx', sort: 'asc' },
    data: jxnrData
  })
}
// 删除试题
const delGw = (index) => {
  xszys.value.splice(index, 1)
  stids.value.splice(index, 1)
}
// 提交
const submit = async () => {
  ruleForm.value.zylx = zylxData.value.xianShangZuoYe
  ruleForm.value.xszys = xszys.value
    ? xszys.value.map((item) => ({ stid: item.id, fz: item.jyksdf }))
    : []
  submitForm({
    url: '/api/v2/ziyuanku/zuoye',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function () {
      closeWindow('openAdd', emits, true)
    }
  })
}
const zylxData = ref({ list: [] })
watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      loadSelect({ url: '/api/v2/ziyuanku/zuoye/zuoyeleixing', data: zylxData, loadSuccess: function (res) { ruleForm.value.zylx = res.data.xianShangZuoYe } })
      loadSelect({
        url: '/api/v2/jiaowu/kecheng/jiaoshi',
        data: kcData,
        order: 'kch',
        sort: 'asc'
      })
      loadSelect({
        url: '/api/v2/pdp/xueqi/list',
        data: xqData,
        order: 'sx',
        sort: 'asc',
        loadSuccess: function (res) {
          if (ruleForm.value.xqid === undefined) {
            if (res.data.length) {
              res.data.forEach((item) => {
                if (item.sfdqxq === true) {
                  ruleForm.value.xqid = item.id
                }
              })
            }
          }
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
.zuo-ye {
  :deep(.el-dialog__body) {
    height: calc(100% - 52px);
    .el-tabs__content,
    .el-tab-pane {
      height: 100%;
    }
  }
  :deep(.box-card) {
    height: 100%;
  }
  :deep(.el-form) {
    height: calc(100% - 56px);
  }
  :deep(.el-card__body) {
    height: calc(100% - 60px);
    overflow: auto;
  }
  .button-box {
    justify-content: space-between;
  }
}
</style>
